import type { HTMLAttributes } from "react";
import clsx from "clsx";
import styles from "./MobileType.module.scss";

export type MobileTypeProps = HTMLAttributes<HTMLElement>;

/**
 * `.m-display` (`m-tokens.css`) — the mobile hero display type: Archivo Black 900, UPPERCASE,
 * −0.02em tracking, line-height 0.95. A block element by default; layer semantics with your own heading if
 * needed. One of the two mobile primitives promotes from CSS utility classes to `@cntrl/ui` components.
 */
export function MDisplay({ className, children, ...rest }: MobileTypeProps) {
  return (
    <div className={clsx(styles.mDisplay, className)} {...rest}>
      {children}
    </div>
  );
}

/**
 * `.m-eyebrow` — the mobile section eyebrow: JetBrains Mono 10px/700, 0.18em tracking, UPPERCASE.
 * Inline by default (renders a `<span>`). The second of the two mobile primitives promoted to a component.
 */
export function MEyebrow({ className, children, ...rest }: MobileTypeProps) {
  return (
    <span className={clsx(styles.mEyebrow, className)} {...rest}>
      {children}
    </span>
  );
}
